// src/router.js
// Optimización: Lazy loading de rutas con dynamic imports.
// Vite divide el bundle y carga cada vista sólo cuando el usuario navega a ella,
// reduciendo el tiempo de carga inicial de la aplicación.
import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from './layouts/MainLayout.vue'
import LoginView from './views/Login.vue'
import { useSessionStore } from './stores/session'

const routes = [
  // Ruta pública — carga eager (primera vista que ve el usuario)
  {
    path: '/login',
    component: LoginView
  },

  // Rutas protegidas con lazy loading
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('./views/Home.vue')
      },
      {
        path: 'usuarios',
        component: () => import('./views/Usuarios.vue'),
        meta: { role: 'admin' }
      },
      {
        path: 'admin',
        component: () => import('./views/Admin.vue'),
        meta: { role: 'admin' }
      },
      {
        path: 'maquinas',
        component: () => import('./views/Maquinas.vue'),
        meta: { role: ['admin', 'tecnico', 'inspector'] }
      },
      {
        path: 'rastrear',
        name: 'rastrear',
        component: () => import('./views/BuscarMaquinas.vue'),
        meta: { role: ['admin', 'tecnico'] }
      },
      {
        path: 'ot',
        component: () => import('./views/OtLista.vue')
      },
      {
        path: 'ot/buscar',
        component: () => import('./views/OtBuscar.vue')
      },

      {
        path: 'perfil',
        component: () => import('./views/UserProfile.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/maki-ot/'),
  routes
})

router.beforeEach(async (to, from, next) => {
  const session = useSessionStore()

  if (to.meta.requiresAuth) {
    // Solo llama al servidor si aún no tenemos usuario cacheado.
    // Esto evita un HTTP request en cada navegación interna.
    if (!session.user) {
      const isAuth = await session.checkAuth()
      if (!isAuth) return next('/login')
    }

    if (to.meta.role) {
      const rolesPermitidos = Array.isArray(to.meta.role) ? to.meta.role : [to.meta.role]
      if (!rolesPermitidos.includes(session.user?.rol)) {
        return next('/')
      }
    }
  }

  next()
})

export default router
